<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1275"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1279"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1289"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1287" /></clipPath></defs><g
     id="g1281"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1283"><g
         id="g1285"
         clip-path="url(#clipPath1289)"><g
           id="g1291"
           transform="translate(341.8047,350.3545)"><path
             d="m 0,0 h -44.587 c 0,0 23.611,42.774 27.495,47.564 3.94,4.819 7.681,1.815 8.022,-2.437 0.368,-4.28 -0.171,-66.075 -0.171,-66.075"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1293" /></g><g
           id="g1295"
           transform="translate(194.438,397.4092)"><path
             d="m 0,0 h 27.466 l 27.24,-56.947 43.356,87.163 h 83.886"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1297" /></g><g
           id="g1299"
           transform="translate(356.5156,284.4219)"><path
             d="M 0,0 19.218,-54.197"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1301" /></g><g
           id="g1303"
           transform="translate(394.8667,284.4219)"><path
             d="M 0,0 -26.502,-76.676"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1305" /></g><g
           id="g1307"
           transform="translate(274.9668,284.4219)"><path
             d="M 0,0 -38.635,-51.221"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1309" /></g><g
           id="g1311"
           transform="translate(238.2881,284.4219)"><path
             d="M 0,0 39.542,-52.128"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1313" /></g><g
           id="g1315"
           transform="translate(315.8403,279.7729)"><path
             d="M 0,0 V -40.591"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1317" /></g><g
           id="g1319"
           transform="translate(335.9087,259.7324)"><path
             d="M 0,0 H -40.59"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1321" /></g><g
           id="g1323"
           transform="translate(212.6924,214.3223)"><path
             d="M 0,0 C -24.32,24.321 -24.32,63.75 0,88.042"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1325" /></g><g
           id="g1327"
           transform="translate(415.1338,214.3223)"><path
             d="M 0,0 C 24.32,24.321 24.32,63.75 0,88.042"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1329" /></g><g
           id="g1331"
           transform="translate(259.1499,172.4268)"><path
             d="M 0,0 H -52.042"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1333" /></g><g
           id="g1335"
           transform="translate(259.1499,140.1694)"><path
             d="M 0,0 H -52.042"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1337" /></g><g
           id="g1339"
           transform="translate(504.4883,427.0869)"><path
             d="m 0,0 h -65.109 c -4.734,0 -8.617,3.884 -8.617,8.617 v 68.796"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1341" /></g><g
           id="g1343"
           transform="translate(504.4883,427.0869)"><path
             d="m 0,0 h -65.109 c -4.734,0 -8.617,3.884 -8.617,8.617 v 68.796"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1345" /></g><g
           id="g1347"
           transform="translate(146.3184,79.7075)"><path
             d="m 0,0 v 416.175 c 0,4.762 3.855,8.617 8.617,8.617 H 284.444 L 358.17,347.379 V -19.474 c 0,-4.734 -3.883,-8.617 -8.617,-8.617 h -22.449"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1349" /></g><g
           id="g1351"
           transform="translate(96.2324,271.4678)"><path
             d="m 0,0 v 189.493 c 0,4.734 3.883,8.617 8.617,8.617 H 50.086 M 0,-195.559 V -34.61"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1353" /></g><g
           id="g1355"
           transform="translate(324.7515,79.7075)"><path
             d="m 0,0 h 133.988 c 8.078,0 14.682,-6.605 14.682,-14.684 v -21.429 -21.401 c 0,-8.079 -6.604,-14.683 -14.682,-14.683 h -343.374 c -10.46,0 -7.993,-0.369 -17.773,3.344 l -85.744,28.942 c -5.782,2.182 -5.782,5.442 0,7.625 l 85.744,28.941 c 9.78,3.713 7.313,3.345 17.773,3.345 h 176.392"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1357" /></g><g
           id="g1359"
           transform="translate(413.2734,79.7075)"><path
             d="M 0,0 V -72.197"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1361" /></g><g
           id="g1363"
           transform="translate(106.4082,79.4521)"><path
             d="M 0,0 V -71.687"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1365" /></g><g
           id="g1367"
           transform="translate(56.8042,24.6025)"><path
             d="M 0,0 V 38.012"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1369" /></g><g
           id="g1371"
           transform="translate(375.0073,79.7075)"><path
             d="M 0,0 V -72.197"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1373" /></g></g></g></g></svg>
</template>
